import React, { Fragment, useEffect } from 'react';
import {
  Card,
  Column,
  Row,
  Subheading,
  Link,
  Text,
  PlaceholderParagraph,
  EmptyState,
  Spinner
} from '@innovaccer/design-system';
import ReviewUpdate from './reviewUpdate';
import pageNotLoaded from '../../../assets/images/pageNotLoaded.png';
import api from '../../../api';
import classes from './styles.module.css';
import { formatDate } from '../../../utils/utils';

function VersionDetails(props) {
  const [showVersionUpdate, setShowVersionUpdate] = React.useState(false);
  const [versionData, setVersionData] = React.useState({
    loading: true,
    data: {},
    error: false
  });

  const { data, loading, error } = versionData;

  useEffect(() => {
    getDeployedStandardETLDetails();
  }, []);

  const getDeployedStandardETLDetails = () => {
    api
      .getDeployedStandardETL()
      .then((res) => {
        setVersionData({
          ...versionData,
          data: res,
          loading: false,
          error: false
        });
      })
      .catch(() => {
        setVersionData({
          ...versionData,
          data: {},
          loading: false,
          error: true
        });
      });
  };

  const closeVersionUpdate = () => {
    setShowVersionUpdate(false);
  };

  return (
    <Fragment>
      <Card className="w-50 my-8 p-6 m-auto">
        {!error && (
          <Fragment>
            <div className="p-4">
              <Subheading>Current version</Subheading>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <div className="w-100 d-flex flex-row p-4">
                <div className={classes.VersionDetailsKey}>
                  <Text appearance="disabled">Version</Text>
                </div>
                <div className="VersionDetails-value w-100">
                  {loading ? (
                    <PlaceholderParagraph data-testid="version-loader" />
                  ) : (
                    <Text>Standard-etl - {data.current_version.version}</Text>
                  )}
                </div>
              </div>
              {!loading && data.is_update_available && (
                <div className="w-25">
                  <Link size="tiny" className="cursor-pointer" onClick={() => setShowVersionUpdate(true)}>
                    Update available
                  </Link>
                </div>
              )}
            </div>
            <div className="d-flex flex-row p-4">
              <div className={classes.VersionDetailsKey}>
                <Text appearance="disabled">Last updated on</Text>
              </div>
              <div className="VersionDetails-value w-100">
                {loading ? <PlaceholderParagraph /> : <Text>{formatDate(data.current_version.last_updated_on)}</Text>}
              </div>
            </div>
          </Fragment>
        )}
        {!loading && error && (
          <EmptyState size="large" title="Failed to fetch standard etl data" imageSrc={pageNotLoaded} />
        )}
      </Card>
      {showVersionUpdate && (
        <ReviewUpdate
          currentVersion={data.current_version.version}
          getDeployedStandardETLDetails={getDeployedStandardETLDetails}
          closeHandler={closeVersionUpdate}
        />
      )}
    </Fragment>
  );
}

export default VersionDetails;
